/* global axios */
import ApiClient from './ApiClient';

class CommissionLaunchesApi extends ApiClient {
  constructor() {
    super('commission_launches', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  stats(params = {}) {
    return axios.get(`${this.url}/stats`, { params });
  }

  // Preview READ-ONLY da comissão a partir dos produtos do card (não persiste nada).
  preview(data) {
    return axios.post(`${this.url}/preview`, data);
  }
}

// Painel de comissões do consultor (escopado por user no backend).
class CommissionDashboardApi extends ApiClient {
  constructor() {
    super('commission_dashboard', { accountScoped: true });
  }

  show(params = {}) {
    return axios.get(this.url, { params });
  }
}

class CommissionPoliciesApi extends ApiClient {
  constructor() {
    super('commission_policies', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

class CommissionGoalConfigsApi extends ApiClient {
  constructor() {
    super('commission_goal_configs', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

class CommissionMovementTypesApi extends ApiClient {
  constructor() {
    super('commission_movement_types', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

class CommissionConsultantClosuresApi extends ApiClient {
  constructor() {
    super('commission_consultant_closures', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  byCompetence(competence) {
    return axios.get(`${this.url}/by_competence`, { params: { competence } });
  }

  generate(id) {
    return axios.post(`${this.url}/${id}/generate`);
  }

  approve(id) {
    return axios.post(`${this.url}/${id}/approve`);
  }

  markPaid(id) {
    return axios.post(`${this.url}/${id}/mark_paid`);
  }

  reopen(id) {
    return axios.post(`${this.url}/${id}/reopen`);
  }

  download(id) {
    return axios.get(`${this.url}/${id}/download`, { responseType: 'blob' });
  }
}

class CommissionCompetenceClosuresApi extends ApiClient {
  constructor() {
    super('commission_competence_closures', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  generate(id) {
    return axios.post(`${this.url}/${id}/generate`);
  }
}

class CommissionManualAdjustmentsApi extends ApiClient {
  constructor() {
    super('commission_manual_adjustments', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

class CommissionAuditLogsApi extends ApiClient {
  constructor() {
    super('commission_audit_logs', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }
}

class CommissionLaunchImportsApi extends ApiClient {
  constructor() {
    super('commission_launch_imports', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  preview(formData) {
    return axios.post(`${this.url}/preview`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  create(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

class CommissionExtraCampaignsApi extends ApiClient {
  constructor() {
    super('commission_extra_campaigns', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  apply(id) {
    return axios.post(`${this.url}/${id}/apply`);
  }
}

export const commissionLaunchesApi = new CommissionLaunchesApi();
export const commissionDashboardApi = new CommissionDashboardApi();
export const commissionPoliciesApi = new CommissionPoliciesApi();
export const commissionGoalConfigsApi = new CommissionGoalConfigsApi();
export const commissionMovementTypesApi = new CommissionMovementTypesApi();
export const commissionConsultantClosuresApi =
  new CommissionConsultantClosuresApi();
export const commissionCompetenceClosuresApi =
  new CommissionCompetenceClosuresApi();
export const commissionManualAdjustmentsApi =
  new CommissionManualAdjustmentsApi();
export const commissionAuditLogsApi = new CommissionAuditLogsApi();
export const commissionLaunchImportsApi = new CommissionLaunchImportsApi();
export const commissionExtraCampaignsApi = new CommissionExtraCampaignsApi();
